import React, { FC } from "react";
import { Provider } from "react-redux";
import { InjectGlobalStyles } from "@evergis/ui";
import { EvergisProvider, MapProvider } from "@evergis/react";
import { WaitFor } from "@evergis/react-fetching";

import { App } from "./App";
import { ThemeProvider } from "./ThemeProvider";
import { api } from "../evergis/api";
import { map } from "../evergis/map";
import { painter } from "../evergis/painter";
import { login } from "../resources/user";
import { store } from "../ducks/store";

export const Root: FC = () => {
  return (
    <Provider store={store}>
      <ThemeProvider>
        <EvergisProvider api={api}>
          <MapProvider map={map} painter={painter}>
            <InjectGlobalStyles />
            <WaitFor resource={login}>
              <App />
            </WaitFor>
          </MapProvider>
        </EvergisProvider>
      </ThemeProvider>
    </Provider>
  );
};
